import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
// import { Modal, ModalBody } from 'reactstrap';
// i18n for legacy components

// Custom HOCs
import { withRouter } from '../../helpers/hocs';
import { withTranslation, Trans } from 'react-i18next';

// Actions
import { gameActions } from '../../actions';
import { setupSocket, enterBackend, socketOn } from '../../helpers/sockets';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';

const nodes = ['Anything else'];
const entities = [
  'BasicAttributes',
  'Importance',
  'Collaborators',
  'Comparison',
  'Satisfaction',
  'Action',
  'RFP',
];
const entitiesOther = ['sys-person'];
const classTags = { basic: [], value: [], other: [], irrelevant: [] };
// Basic
const basicIntents = ['Satisfaction'];
// Other
const otherIntents = ['Hello', 'Goodbye', 'Introduction', 'SmallTalk'];

class DebriefAggregate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_player: null,
      proposals: [],
    };

    // Bindings
    this.setProposals = this.setProposals.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    if (match.params.id) {
      // dispatch(gameActions.fetchGames(match.params.id))
      fetch(process.env.REACT_APP_API_URL + '/auth/oauth_provider')
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          setupSocket(data.io_domain, () => {
            enterBackend({ game_id: match.params.id }, (socketGameData) => {
              console.log({ socketGameData });
            });
            // Sockets!
            socketOn('offer', (m) => {
              dispatch(gameActions.fetchGames(match.params.id));
            }); // socketOn('nodeal', (m) => console.log(m) );
          });
        });
    }
  }

  setProposals(proposals) {
    this.setState({ proposals });
  }

  render() {
    const { game, t } = this.props;
    if (!game.data) return null;

    // INTENTS: CHART DATA ALL
    game.data.players.forEach(function (players) {
      players.chat.forEach(function (c) {
        if (c.wdata) {
          const output = c.wdata.output || c.wdata.debug;
          // Validating "Anything else" against nodes_visited
          var valueBasedNode = output.nodes_visited.some(function (n) {
            return nodes.indexOf(n) > -1;
          });
          if (valueBasedNode) {
            classTags.irrelevant.push('Anything else');

            // Ok, let's decide if it is basic, other or value-based
          } else {
            // This intent should fall into OTHER or BASIC
            // Both arrays contain unique strings
            var firstIntent = c.wdata.intents[0]
              ? c.wdata.intents[0].intent || ''
              : '';

            // Validate if this message contains
            // intents categorized as "other"
            if (otherIntents.indexOf(firstIntent) > -1)
              return classTags.other.push(firstIntent);

            // Validate if this message contains
            // intents categorized as "basic"
            if (basicIntents.indexOf(firstIntent) > -1)
              return classTags.basic.push(firstIntent);

            // Validate if this message contains
            // entities categorized as "basic"
            var match = c.wdata.entities.some(function (entityObj) {
              if (entityObj.entity == 'Collaborators')
                return (
                  entities.indexOf(entityObj.entity) > -1 &&
                  entityObj.value == 'Procurement Manager'
                );

              if (entityObj.entity == 'Action')
                return (
                  entities.indexOf(entityObj.entity) > -1 &&
                  entityObj.value == 'Pay'
                );

              return entities.indexOf(entityObj.entity) > -1;
            });
            if (match) return classTags.basic.push(firstIntent);

            // Validate if this message contains
            // entities categorized as "other"
            var matchOther = c.wdata.entities.some(function (entityObj) {
              return entitiesOther.indexOf(entityObj.entity) > -1;
            });
            if (matchOther) return classTags.other.push(firstIntent);

            // If the validations got to this point,
            // then it's a value-based message
            return classTags.value.push(firstIntent);
          }
        }
      });
    });

    return (
      <div>
        <Header />

        <h2 className='mt-3 sec-title fs-3'>
          {t('Aggregate')}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2>

        <div className='mt-3 pb-2 row'>
          <div className='col-12'>
            <HighchartsReact
              containerProps={{ style: { height: '100%', paddingTop: '20px' } }}
              highcharts={Highcharts}
              options={{
                chart: { type: 'column', style: { fontSize: '14px' } },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: {
                  labels: { style: { fontSize: '14px' } },
                  categories: ['Basic', 'Value-Based', 'Other'],
                },
                yAxis: {
                  labels: { style: { fontSize: '14px' } },
                  allowDecimals: false,
                  min: 0,
                  title: { text: '' },
                },
                tooltip: {
                  style: { fontSize: '14px' },
                  formatter: function () {
                    if (this.point.category == 'Total')
                      return (
                        '<span style="color:{series.color}">' +
                        this.series.name +
                        '</span>: <b>' +
                        this.y +
                        '</b>'
                      );
                    else
                      return (
                        '<span style="color:{series.color}">' +
                        this.series.name +
                        '</span>: <b>' +
                        this.y +
                        '</b>'
                      );
                  },
                  //pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>Click to see details.'
                },
                plotOptions: {
                  column: {
                    dataLabels: {
                      enabled: true,
                      crop: false,
                      overflow: 'none',
                    },
                  },
                },
                series: [
                  {
                    name: 'Count',
                    data: [
                      classTags.basic.length,
                      classTags.value.length,
                      classTags.other.length,
                    ],
                  },
                ],
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

// With translation
const DebriefAggregateWithTranslation = withTranslation()(DebriefAggregate);

// Router HOC
const DebriefAggregateWithRouter = withRouter(DebriefAggregateWithTranslation);

const mapStateToProps = (state) => {
  const { game } = state;
  return {
    game,
  };
};

export default connect(mapStateToProps)(DebriefAggregateWithRouter);
